import { KENALL, type AddressResolverResponse } from '@ken-all/kenall'

const KENALL_API_KEY = '97e1cc62e74a0b3e66917bcc4bf6a2f82b0da51c'

const API_BASE_URL = 'https://api.kenall.jp/v1'
const API_REQUEST_HEADERS = {
  authorization: `token ${KENALL_API_KEY}`,
}

const kenall = new KENALL(KENALL_API_KEY, {
  // デフォルト1秒でのタイムアウトによるエラーが何件か起きていたので、タイムアウト時間を延ばす
  timeout: 3 * 1000,
})

export function getAddress(
  postalCode: string
): Promise<AddressResolverResponse> {
  return kenall.getAddress(postalCode)
}

// https://kenall.jp/docs/API/holidays/#get-v1holidaysyear
export type GetHolidaysYearResponse = {
  data: {
    title: string
    date: string
    day_of_week: number
    day_of_week_text: string
  }[]
}

export async function getHolidaysYear(
  year: number
): Promise<GetHolidaysYearResponse> {
  const res = await fetch(`${API_BASE_URL}/holidays?year=${year}`, {
    headers: API_REQUEST_HEADERS,
  })
  return res.json()
}
